import { Button } from '@mui/joy';

export const ModalButtons = ({
  cta,
  ctaButtonType,
  onCTA,
  onCancel,
  isLoading,
  onBack,
}: {
  cta: string;
  ctaButtonType: 'submit' | 'button';
  onCancel: () => void;
  onCTA?: () => void;
  isLoading?: boolean;
  onBack?: () => void;
}) => {
  return (
    <div className="flex w-full flex-row gap-2">
      <Button onClick={onCancel} variant="outlined" color="neutral">
        Cancel
      </Button>
      <div className="flex-grow" />
      {onBack && (
        <Button onClick={onBack} variant="outlined" color="neutral">
          Back
        </Button>
      )}
      <Button
        onClick={onCTA}
        color="primary"
        type={ctaButtonType}
        loading={isLoading}
      >
        {cta}
      </Button>
    </div>
  );
};

export const Split = ({ children }: { children: React.ReactNode }) => {
  return <div className="grid grid-cols-2 gap-4">{children}</div>;
};

const FieldTitle = ({ title }: { title: string }) => {
  return <div className="text-xs font-medium text-primary">{title}</div>;
};

const FieldDescription = ({ description }: { description: string }) => {
  return <div className="text-xs text-tertiary">{description}</div>;
};

export const FieldConfig = ({
  title,
  children,
  description,
}: {
  title: string;
  children: React.ReactNode;
  description?: string;
}) => {
  return (
    <div className="flex flex-col gap-2">
      <FieldTitle title={title} />
      {children}
      {description && <FieldDescription description={description} />}
    </div>
  );
};
